export * from './redirectToLegacy';
